import React, { useState } from 'react'
import { Row, Col, Form, Button } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
// import { ReactComponent as Logo } from '../../assets/images/logo.svg'
import { ReactComponent as Logo } from '../../assets/images/footerlogo.svg'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import InputControl from '../../components/InputControl'
import { useMutation } from 'react-query'
import requestApi from '../../utils/request'
import ButtonWithLoader from '../../components/ButtonWithLoader'
import { ReactComponent as ForgotIcon } from '../../assets/images/forgot-pwd.svg'
import { ReactComponent as BackIcon } from '../../assets/images/left-arrow.svg'
import Swal from 'sweetalert2'
import { signin } from '../../Routes/routingConsts'


const forgotPassValidationSchema = yup.object().shape({
    email: yup
        .string()
        .email('Please enter a valid email')
        .required('Please enter email')
})

const ForgotPassword = () => {

    const [emailSent, setEmailSent] = useState('')
    const navigate = useNavigate()
    async function adminForgotPassword(email) {
        return await requestApi.post('/forgot-password', email)
    }

    const {
        register,
        handleSubmit,
        reset,
        getValues,
        formState: { errors }
    } = useForm({ resolver: yupResolver(forgotPassValidationSchema) })

    const mutation = useMutation(adminForgotPassword, {
        onSuccess: (res) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                 text:res?.data?.meta?.message
            }).then(()=> navigate(signin))
           
            reset()
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })

    const handleOnSubmit = ({ email }) => {
        mutation.mutate({
            email
        })
    }

  return (
    <>
       {/* <div className="login-header">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="header-logo">
                                <Logo />
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
    <div className="forgot-password auth-page">
        <div className="container">
            <div className="forgot-pwd auth-center auth-wrapper">
                <div className="previous-page-icon for-mobile-back-btn">
                    <Link to={signin}>
                        <span className="back-btn">
                            <BackIcon className="back-icon" /> Back
                        </span>
                    </Link>
                </div>

                <Row className="row">
                    {/* <Col className="auth-image">
                        <ForgotIcon />
                    </Col> */}
                    <Col className="comman-form-col form-wrapper forgot-pwd-form m-0">
                        <div className="previous-page-icon for-desktop-back-btn">
                            <Link to={signin}>
                                <span className="back-btn">
                                    <BackIcon className="back-icon" />{' '}
                                    Back
                                </span>
                            </Link>
                        </div>
                        <div className="forgot-form center-form">
                            <div className="form-title">
                                <h2>Forgot Password</h2>
                                <p>
                                    Enter your email id and we will send
                                    you a link to reset your password.
                                </p>
                            </div>
                            <Form
                                onSubmit={handleSubmit(handleOnSubmit)}
                            >
                                <InputControl
                                    label="Email Address"
                                    name="email"
                                    register={register}
                                    error={errors.email?.message}
                                />
                                <ButtonWithLoader  
                                isLoading={mutation?.isLoading}
                                cssClass="common-btn comman-auth-btn reset-btn"> 
                                <Button
                                    className="common-btn comman-auth-btn reset-btn"
                                    type="Submit"
                                >
                                    Reset Password
                                </Button>
                                </ButtonWithLoader>
                            </Form>
                            {!!emailSent && emailSent}
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</>
  )
}

export default ForgotPassword